import { useNavigate } from 'react-router-dom'
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid'
import { usePacientes } from '../../data/hooks/usePacientes.hook'
import { useAuth } from '../../auth/AuthContext'
import { Role } from '../../data/types/medico.types'
import { Spinner } from '../../components/spinner/Spinner.component'
import { Paciente } from '../../pagesApp/loginApp.types'



export const PacientesBrowse = () => {
	const { role } = useAuth()
	const navigate = useNavigate()
	const { data, isPending, isError, error } = usePacientes()

	const columns: ColumnConfig[] = [
		{
			key: 'nombre',
			header: 'Nombre',
			dataType: 'text',
			filterable: true,
			sortable: true,
		},
		{
			key: 'apellido',
			header: 'Apellido',
			dataType: 'text',
			filterable: true,
			sortable: true,
		},
		{
			key: 'dni',
			header: 'DNI',
			dataType: 'text',
			filterable: true,
			sortable: true,
		},
		// {
		// 	key: 'provincia',
		// 	header: 'Provincia',
		// 	dataType: 'text',
		// 	filterable: true,
		// 	sortable: true,
		// },
	]

	const rowActions = [
		{
			label: '',
			action: (selected: Paciente[]) => navigate(`/med/paciente/${selected[0].dni}`),
			icon: '✏️'
		}
	]

	if (role !== Role.ADMIN) return <div>No tienes permisos para ver esta página</div>

	if (isPending) return <Spinner />
	
	return (
		<div style={{ margin: '0 150px' }}>
			{isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>}
			{(!isPending && !isError) && <SmartGrid
				data={data || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'nombre', direction: 'desc' }}
				toolbarComponents={[
				  {
					type: 'title',
					title: 'Pacientes',
					count: true,
				  },
				]}
			/>}
		</div>		
	)

}